module.exports = __webpack_public_path__ + "OrangeStrategy.eb0da97.png";